import React from 'react';

interface AvatarProps {
  src?: string | null;
  name?: string | null;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function getColorFromName(name: string): string {
  const colors = [
    '#2a6b75', '#5b8a3c', '#8b5e3c', '#6b4a8f', '#3c6b8b',
    '#8b3c5e', '#4a7a5e', '#7a5e3c', '#3c5e8b', '#6b3c8b',
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
}

export function Avatar({ src, name, size = 36, className, style }: AvatarProps) {
  const [imgLoaded, setImgLoaded] = React.useState(false);
  const [imgError, setImgError] = React.useState(false);
  React.useEffect(() => {
    setImgLoaded(false);
    setImgError(false);
  }, [src]);
  const label = name || '?';
  const initials = getInitials(label);
  const bg = getColorFromName(label);

  const containerStyle: React.CSSProperties = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    userSelect: 'none',
    position: 'relative',
    background: bg,
    boxSizing: 'border-box',
    ...style,
  };

  if (src && !imgError) {
    return (
      <div className={className} style={containerStyle} title={label}>
        <img
          src={src}
          alt={label}
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgError(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            display: 'block',
          }}
        />
        {!imgLoaded && (
          <span style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: size * 0.38,
            color: '#fff',
          }}>
            {initials}
          </span>
        )}
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        ...containerStyle,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        fontSize: size * 0.38,
        color: '#fff',
      }}
      title={label}
    >
      {initials}
    </div>
  );
}
